module.exports = __webpack_public_path__ + "img/mobile/PromoHistory/Promo_Spin_Icon@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/PromoHistory/Promo_Spin_Icon@2x.png
// module id = 119
// module chunks = 0